var React = require('react');

function PlusMini (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9","cy":"9","r":"8","fill":"white","stroke":"black","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M10.0791 13V9.94845H13V8.05155H10.0791V5H7.92089V8.05155H5V9.94845H7.92089V13H10.0791Z","fill":"black","key":1})]);
}

PlusMini.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = PlusMini;

PlusMini.default = PlusMini;
